// vendor
import { defineComponent, ref, computed, onUnmounted, onBeforeMount } from "@vue/composition-api";
// project
import { Dictionary } from "@/utils/types";
import { formatDuration } from "@/utils/text";

export const LiveTimer = defineComponent({
	props:{
		start:{
			type:Number,
			required:true
		},
		end:{
			type:Number,
			required:true
		},
		stopped:{
			type:Number,
			required:false
		}
	},
	setup(props){

		const tick = ref<NodeJS.Timeout>();
		const time = ref(Date.now());

		const icon = computed(() => states[state.value].icon);
		const theme = computed(() => states[state.value].theme);
		const totalTime = computed(() => props.end - props.start);
		const done = computed(() => Boolean(props.stopped));

		const expired = computed(() => {
			if(props.stopped && props.stopped < props.end){ return false; }
			return time.value > props.end;
		});

		const state = computed(() => {
			if(expired.value){ return "expired"; }
			else if(done.value){ return "done"; }
			return "running"
		});

		const progress = computed(() => {
			let t = time.value - props.start;
			if(props.stopped){
				t = props.stopped - props.start;
			}
			const p = t / totalTime.value;
			return p > 1 ? 1 : p;
		});

		const progressLabel = computed(() => {
			const rm = totalTime.value - (totalTime.value * progress.value);
			return formatDuration(rm);
		})

		const stop = () => {
			if(tick.value){ clearInterval(tick.value); }
			tick.value = undefined;
		};

		const onTick = () => {
			time.value = Date.now();
		};

		onBeforeMount(() => {
			if(done.value || expired.value){ return; }
			tick.value = setInterval(onTick, 1000);
			onTick();
		});

		onUnmounted(stop);

		return {
			progress,
			icon,
			theme,
			progressLabel,
		};
	}
	
})

type State = {
	icon:string,
	theme:string
};

const states:Dictionary<State> = {
	running:{ icon:"mdi.clock-outline", theme:"warning" },
	done:{ icon:"mdi.clock-check-outline", theme:"success" },
	expired:{ icon:"mdi.clock-alert-outline", theme:"danger" }
};